module.exports = __webpack_public_path__ + "img/windows.068f1e29.png";